import { defineStore } from 'pinia'
import Image from '@/classes/files/Image'

export const useFileStore = defineStore('FileStore', {
  state: () => ({
    loader: false,
    error: {}
  }),
  actions: {
    getImage ({ url }) {
      return this.$fetchFile({ url }).then(image => new Image([image]))
    },
    postFile ({ params }) {
      return this.$postFile({
        endpoint: '/api/v1/files',
        params
      })
    }
  }
})